import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { useImmerReducer } from 'use-immer';
import {
    Grid, Snackbar, Typography, Button, TextField, MenuItem,
    Alert, Container, Paper, Box, CircularProgress
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import StateContext from "../../../Contexts/StateContext";

import {
    areaOptions, AranyosszekOptions, CsikszekOptions, GyergyoszekOptions, KaszonfiuszekOptions, KereszturfiuszekOptions,
    KezdiszekOptions, MarosszekOptions, MiklosvarfiuszekOptions, OrbaiszekOptions, SepsiszekOptions, UdvarhelyszekOptions, CsangofoldOptions,
} from "../../../Constants/GeographicConstants";

function AddCar() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const GlobalState = useContext(StateContext);

    const config = require('../../../config').default;
    const environment = require('../../../config').environment;

    const initialState = {
        titleValue: '',
        descriptionValue: '',
        areaValue: '',
        boroughValue: '',
        priceValue: '',
        currencyValue: 'RON',
        brandValue: '',
        modelValue: '',
        yearValue: '',
        engineSizeValue: '',
        fuelValue: '',
        mileageValue: '',
        transmissionValue: '',
        conditionValue: '',
        powerValue: '',
        featuresValue: '',
        seatsValue: '',
        latitudeValue: 45.8643,
        longitudeValue: 25.7848,
        uploadedPictures: [],
        addressValue: '',
        geocodingError: '',
        geocodingSuccess: false,
        sendRequest: 0,
        openSnack: false,
        disabledBtn: false,
        error: '',
    };

    function ourReducer(draft, action) {
        switch (action.type) {
            case 'catchTitleChange': draft.titleValue = action.value; break;
            case 'catchDescriptionChange': draft.descriptionValue = action.value; break;
            case 'catchAddressChange':
                draft.addressValue = action.value;
                draft.geocodingError = '';
                draft.geocodingSuccess = false;
                break;
            case 'catchLatitudeChange':
                draft.latitudeValue = action.value;
                break;
            case 'catchLongitudeChange':
                draft.longitudeValue = action.value;
                break;
            case 'setGeocodingError':
                draft.geocodingError = action.value;
                draft.geocodingSuccess = false;
                break;
            case 'setGeocodingSuccess':
                draft.geocodingSuccess = true;
                draft.geocodingError = '';
                break;
            case 'catchAreaChange': draft.areaValue = action.value; break;
            case 'catchBoroughChange': draft.boroughValue = action.value; break;
            case 'catchPriceChange': draft.priceValue = action.value; break;
            case 'catchBrandChange': draft.brandValue = action.value; break;
            case 'catchModelChange': draft.modelValue = action.value; break;
            case 'catchYearChange': draft.yearValue = action.value; break;
            case 'catchFuelChange': draft.fuelValue = action.value; break;
            case 'catchEngineSizeChange': draft.engineSizeValue = action.value; break;
            case 'catchCurrencyChange': draft.currencyValue = action.value; break;
            case 'catchMileageChange': draft.mileageValue = action.value; break;
            case 'catchTransmissionChange': draft.transmissionValue = action.value; break;
            case 'catchConditionChange': draft.conditionValue = action.value; break;
            case 'catchPowerChange': draft.powerValue = action.value; break;
            case 'catchFeaturesChange': draft.featuresValue = action.value; break;
            case 'catchSeatsChange': draft.seatsValue = action.value; break;
            case 'catchUploadedPictures': draft.uploadedPictures = action.value; break;
            case 'changeSendRequest': draft.sendRequest++; break;
            case 'openTheSnack': draft.openSnack = true; break;
            case 'disableTheBtn': draft.disabledBtn = true; break;
            case 'enableTheBtn': draft.disabledBtn = false; break;
            case 'setError': draft.error = action.value; break;
            default: break;
        }
    }

    const [state, dispatch] = useImmerReducer(ourReducer, initialState);

    const getBoroughOptions = () => {
        switch (state.areaValue) {
            case 'Aranyosszék': return AranyosszekOptions;
            case 'Csíkszék': return CsikszekOptions;
            case 'Gyergyószék': return GyergyoszekOptions;
            case 'Kászonszék': return KaszonfiuszekOptions;
            case 'Keresztúrszék': return KereszturfiuszekOptions;
            case 'Kézdiszék': return KezdiszekOptions;
            case 'Marosszék': return MarosszekOptions;
            case 'Miklósvárszék': return MiklosvarfiuszekOptions;
            case 'Orbaiszék': return OrbaiszekOptions;
            case 'Sepsiszék': return SepsiszekOptions;
            case 'Udvarhelyszék': return UdvarhelyszekOptions;
            case 'Csángóföld': return CsangofoldOptions;
            default: return [];
        }
    };

    const handleGeocode = async () => {
        if (!state.addressValue) return;
        try {
            const response = await Axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(state.addressValue)}`);
            if (response.data && response.data.length > 0) {
                const { lat, lon } = response.data[0];
                dispatch({ type: 'catchLatitudeChange', value: parseFloat(lat) });
                dispatch({ type: 'catchLongitudeChange', value: parseFloat(lon) });
                dispatch({ type: 'setGeocodingSuccess' });
            } else {
                dispatch({ type: 'setGeocodingError', value: t('Thematic.GeocodingNoResult', 'Nem található koordináta a megadott címhez.') });
            }
        } catch (e) {
            console.error("Geocoding error:", e);
            dispatch({ type: 'setGeocodingError', value: t('Thematic.GeocodingError', 'Hiba történt a keresés során.') });
        }
    };

    const handleCoordChange = (type, value) => {
        const parsedValue = parseFloat(value);
        if (!isNaN(parsedValue)) {
            if (type === 'lat') dispatch({ type: 'catchLatitudeChange', value: parsedValue });
            else dispatch({ type: 'catchLongitudeChange', value: parsedValue });
        }
    };

    function FormSubmit(e) {
        e.preventDefault();
        dispatch({ type: 'changeSendRequest' });
        dispatch({ type: 'disableTheBtn' });
    }

    useEffect(() => {
        if (state.sendRequest) {
            async function AddCarFunc() {
                const formData = new FormData();
                formData.append('title', state.titleValue);
                formData.append('description', state.descriptionValue);
                formData.append('address', state.addressValue);
                formData.append('area', state.areaValue);
                formData.append('borough', state.boroughValue);
                formData.append('latitude', state.latitudeValue);
                formData.append('longitude', state.longitudeValue);
                formData.append('price', state.priceValue);
                formData.append('currency', state.currencyValue);
                formData.append('seller', GlobalState.userId);
                formData.append('key', 'Auto');
                formData.append('listing_type', 'Auto');
                
                // Add car specific fields
                formData.append('brand', state.brandValue);
                formData.append('model', state.modelValue);
                formData.append('year', state.yearValue);
                formData.append('engine_size_l', state.engineSizeValue);
                formData.append('fuel', state.fuelValue);
                formData.append('mileage', state.mileageValue);
                formData.append('transmission', state.transmissionValue);
                formData.append('condition', state.conditionValue);
                formData.append('power', state.powerValue);
                formData.append('features', state.featuresValue);
                formData.append('seats', state.seatsValue);

                for (let i = 0; i < state.uploadedPictures.length; i++) {
                    formData.append(`picture${i + 1}`, state.uploadedPictures[i]);
                }

                try {
                    const token = GlobalState.jwtAccessToken || localStorage.getItem('jwtAccessToken');
                    await Axios.post(config[environment].createCarEndpoint, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    dispatch({ type: 'openTheSnack' });
                } catch (e) {
                    console.error("Car creation error:", e.response);
                    dispatch({ type: 'enableTheBtn' });
                    dispatch({ type: 'setError', value: t('Common.Error') });
                }
            }
            AddCarFunc();
        }
    }, [state.sendRequest]);

    useEffect(() => {
        if (state.openSnack) {
            setTimeout(() => navigate(`/${i18n.language}/all-car-listings`), 1500);
        }
    }, [state.openSnack]);

    if (!GlobalState.userIsLogged) {
        return (
            <Container maxWidth="sm" sx={{ py: 8 }}>
                <Alert severity="warning">{t('Administration.LoginRequired')}</Alert>
                <Button variant="contained" onClick={() => navigate(`/${i18n.language}/login`)} sx={{ mt: 2 }}>{t('Administration.LoginButton')}</Button>
            </Container>
        );
    }

    return (
        <Container maxWidth="md" sx={{ py: 4, mt: '50px' }}>
            <Paper sx={{ p: 4 }}>
                <Typography variant="h4" gutterBottom sx={{ color: 'var(--sznodarkblue)', fontWeight: 'bold' }}>
                    {t('SubMenu.Car')} +
                </Typography>
                <form onSubmit={FormSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField fullWidth label={t('Common.Title')} value={state.titleValue} onChange={(e) => dispatch({ type: 'catchTitleChange', value: e.target.value })} required />
                        </Grid>
                        
                        {/* Car Specific Fields */}
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth label={t('SubMenu.CarBrand')} value={state.brandValue} onChange={(e) => dispatch({ type: 'catchBrandChange', value: e.target.value })} required />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth label={t('SubMenu.CarModel')} value={state.modelValue} onChange={(e) => dispatch({ type: 'catchModelChange', value: e.target.value })} required />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth type="number" label={t('SubMenu.CarYear')} value={state.yearValue} onChange={(e) => dispatch({ type: 'catchYearChange', value: e.target.value })} required />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth type="number" inputProps={{ step: '0.1' }} label={t('SubMenu.CarEngineSizeL', 'Motor (l)')} value={state.engineSizeValue} onChange={(e) => dispatch({ type: 'catchEngineSizeChange', value: e.target.value })} placeholder="2.0" />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField select fullWidth label={t('SubMenu.CarFuel')} value={state.fuelValue} onChange={(e) => dispatch({ type: 'catchFuelChange', value: e.target.value })} required>
                                <MenuItem value="Gasoline">{t('SubMenu.FuelGasoline')}</MenuItem>
                                <MenuItem value="Diesel">{t('SubMenu.FuelDiesel')}</MenuItem>
                                <MenuItem value="Hybrid">{t('SubMenu.FuelHybrid')}</MenuItem>
                                <MenuItem value="Electric">{t('SubMenu.FuelElectric')}</MenuItem>
                                <MenuItem value="LPG">{t('SubMenu.FuelLPG')}</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField select fullWidth label={t('SubMenu.CarTransmission')} value={state.transmissionValue} onChange={(e) => dispatch({ type: 'catchTransmissionChange', value: e.target.value })} required>
                                <MenuItem value="Manual">{t('SubMenu.TransManual')}</MenuItem>
                                <MenuItem value="Automatic">{t('SubMenu.TransAutomatic')}</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth type="number" label={t('SubMenu.CarMileage')} value={state.mileageValue} onChange={(e) => dispatch({ type: 'catchMileageChange', value: e.target.value })} required />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField select fullWidth label={t('SubMenu.CarCondition')} value={state.conditionValue} onChange={(e) => dispatch({ type: 'catchConditionChange', value: e.target.value })} required>
                                <MenuItem value="New">{t('SubMenu.CondNew')}</MenuItem>
                                <MenuItem value="Used">{t('SubMenu.CondUsed')}</MenuItem>
                                <MenuItem value="Damaged">{t('SubMenu.CondDamaged')}</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth type="number" label={t('SubMenu.CarPower')} value={state.powerValue} onChange={(e) => dispatch({ type: 'catchPowerChange', value: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth type="number" label={t('SubMenu.CarSeats')} value={state.seatsValue} onChange={(e) => dispatch({ type: 'catchSeatsChange', value: e.target.value })} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth multiline rows={2} label={t('SubMenu.CarFeatures')} value={state.featuresValue} onChange={(e) => dispatch({ type: 'catchFeaturesChange', value: e.target.value })} placeholder="pl. klíma, tempomat, vonóhorog..." />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField select fullWidth label={t('Map.Toolbox.szek')} value={state.areaValue} onChange={(e) => dispatch({ type: 'catchAreaChange', value: e.target.value })} required>
                                {areaOptions.map((option) => (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField select fullWidth label={t('Map.Toolbox.telepules')} value={state.boroughValue} onChange={(e) => dispatch({ type: 'catchBoroughChange', value: e.target.value })} required disabled={!state.areaValue}>
                                {getBoroughOptions().map((option) => (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth type="number" label={t('Common.Price')} value={state.priceValue} onChange={(e) => dispatch({ type: 'catchPriceChange', value: e.target.value })} required />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField select fullWidth label={t('Currency', 'Pénznem')} value={state.currencyValue} onChange={(e) => dispatch({ type: 'catchCurrencyChange', value: e.target.value })}>
                                <MenuItem value="RON">RON</MenuItem>
                                <MenuItem value="HUF">HUF</MenuItem>
                                <MenuItem value="EUR">EUR</MenuItem>
                                <MenuItem value="USD">USD</MenuItem>
                                <MenuItem value="GBP">GBP</MenuItem>
                                <MenuItem value="CHF">CHF</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth multiline rows={4} label={t('Common.Description')} value={state.descriptionValue} onChange={(e) => dispatch({ type: 'catchDescriptionChange', value: e.target.value })} />
                        </Grid>

                        <Grid item container sx={{ mt: 2 }} spacing={2}>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label={t('Common.Address')}
                                    value={state.addressValue}
                                    onChange={(e) => dispatch({ type: 'catchAddressChange', value: e.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    onClick={handleGeocode}
                                    sx={{ height: '56px' }}
                                >
                                    {t('Thematic.Geocode')}
                                </Button>
                            </Grid>
                            {state.geocodingError && (
                                <Grid item xs={12}>
                                    <Alert severity="error" sx={{ mt: 1 }}>
                                        {state.geocodingError}
                                    </Alert>
                                </Grid>
                            )}
                            {state.geocodingSuccess && (
                                <Grid item xs={12}>
                                    <Alert severity="success" sx={{ mt: 1 }}>
                                        {t('Thematic.GeocodingSuccess')}
                                    </Alert>
                                </Grid>
                            )}
                        </Grid>

                        <Grid item container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label={t('Map.Latitude', "Földrajzi szélesség")}
                                    type="number"
                                    value={state.latitudeValue}
                                    onChange={(e) => handleCoordChange('lat', e.target.value)}
                                    inputProps={{ step: "0.0001" }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label={t('Map.Longitude', "Földrajzi hosszúság")}
                                    type="number"
                                    value={state.longitudeValue}
                                    onChange={(e) => handleCoordChange('lon', e.target.value)}
                                    inputProps={{ step: "0.0001" }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                component="label"
                                sx={{ bgcolor: 'var(--sznodarkblue)' }}
                            >
                                {t('Common.UploadPictures')}
                                <input
                                    type="file"
                                    multiple
                                    hidden
                                    onChange={(e) => dispatch({ type: 'catchUploadedPictures', value: e.target.files })}
                                />
                            </Button>
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                {state.uploadedPictures.length} {t('Common.PicturesSelected')}
                            </Typography>
                        </Grid>
                    </Grid>
                    {state.error && <Alert severity="error" sx={{ mt: 2 }}>{state.error}</Alert>}
                    <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
                        <Button type="submit" variant="contained" disabled={state.disabledBtn}>{state.disabledBtn ? <CircularProgress size={24} /> : t('Common.Submit')}</Button>
                        <Button variant="outlined" onClick={() => navigate(-1)}>{t('Common.Cancel', 'Mégse')}</Button>
                    </Box>
                </form>
            </Paper>
            <Snackbar open={state.openSnack} message={t('Common.Success', 'Sikeres hirdetésfeladás!')} autoHideDuration={2000} />
        </Container>
    );
}

export default AddCar;